import { PasswordField } from 'src/pages/channel/shared';

import { Field } from 'src/components/hook-form';

export const SmsField = ({ t }: any) => (
  <>
    <Field.Text
      name="accountSid"
      label={t('ACCOUNT_ID')}
      InputLabelProps={{ shrink: true }}
      placeholder={t('ENTER_ACCOUNT_ID')}
    />
    <PasswordField name="authToken" label={t('AUTH_TOKEN')} placeholder={t('ENTER_AUTH_TOKEN')} />
    <Field.Text
      name="srcNumber"
      label={t('SOURCE_NUMBER')}
      InputLabelProps={{ shrink: true }}
      placeholder={t('ENTER_SOURCE_NUMBER')}
    />
  </>
);
